import React, { useRef, useState, useEffect } from "react";
import {  useNavigate, useLocation } from "react-router-dom";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { useForm } from "react-hook-form";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { ToastContainer, toast } from "react-toastify";

import EditUserService from "../../../services/user/editUserService";
import { getTrans as t } from "../../../Localization/translations";
import ButtonLoading from "../../../components/Loder/buttonLoading";
import AuthUserChangePassword from "../../../services/helper/changeUserPassword";
import AuthService from "../../../services/auth.service";

function EditUser() {
  const option3 = [
    { label: "Mr", value: "Mr" },
    { label: "Mrs", value: "Mrs" },
    { label: "Miss", value: "Miss" },
  ];

  const option2 = [
    { label: "en-US", value: "United States" },
    { label: "en_GB", value: "United Kingdom" },
    { label: "en-CA", value: "Canada" },
    { label: "en_IE", value: "Ireland" },
    { label: "en_AU", value: "Australia" },
    { label: "fr_CA", value: "Canada" },
    { label: "fr", value: "France" },
    { label: "de", value: "Germany" },
    { label: "nl_NL", value: "Dutch" },
  ];

  const option = [
    { label: "Etc/GMT+12", value: "(GMT-12:00) International Date Line West" },
    { label: "Pacific/Midway", value: "(GMT-11:00) Midway Island, Samoa" },
    { label: "Pacific/Honolulu", value: "(GMT-10:00) Hawaii" },
    { label: "US/AlaskaUS", value: "(GMT-09:00) Alaska" },
    {
      label: "America/Los_Angeles",
      value: "(GMT-08:00) Pacific Time (US & Canada)",
    },
    { label: "America/Tijuana", value: "(GMT-08:00) Tijuana, Baja California" },
    { label: "US/Arizona", value: "(GMT-07:00) Arizona" },
    {
      label: "America/Chihuahua",
      value: "(GMT-07:00) Chihuahua, La Paz, Mazatlan",
    },
    { label: "US/Mountain", value: "(GMT-07:00) Mountain Time (US & Canada)" },
    { label: "America/Managua", value: "(GMT-06:00) Central America" },
    { label: "US/Central", value: "(GMT-06:00) Central Time (US & Canada)" },
    {
      label: "America/Mexico_City",
      value: "(GMT-06:00) Guadalajara, Mexico City, Monterrey",
    },
    { label: "Canada/Saskatchewan", value: "(GMT-06:00) Saskatchewan" },
    {
      label: "America/Bogota",
      value: "(GMT-05:00) Bogota, Lima, Quito, Rio Branco",
    },
    { label: "US/Eastern", value: "(GMT-05:00) Eastern Time (US & Canada)" },
    { label: "US/East-Indiana", value: "(GMT-05:00) Indiana (East)" },
    { label: "Canada/Atlantic", value: "(GMT-04:00) Atlantic Time (Canada)" },
    { label: "America/Caracas", value: "(GMT-04:00) Caracas, La Paz" },
    { label: "America/Manaus", value: "(GMT-04:00) Manaus" },
    { label: "America/Santiago", value: "(GMT-04:00) Santiago" },
    { label: "Canada/Newfoundland", value: "(GMT-03:30) Newfoundland" },
    { label: "America/Sao_Paulo", value: "(GMT-03:00) Brasilia" },
    {
      label: "America/Argentina/Buenos_Aires",
      value: "(GMT-03:00) Buenos Aires, Georgetown",
    },
    { label: "America/Godthab", value: "(GMT-03:00) Greenland" },
    { label: "America/Montevideo", value: "(GMT-03:00) Montevideo" },
    { label: "America/Noronha", value: "(GMT-02:00) Mid-Atlantic" },
    { label: "Atlantic/Cape_Verde", value: "(GMT-01:00) Cape Verde Is." },
    { label: "Atlantic/Azores", value: "(GMT-01:00) Azores" },
    {
      label: "Africa/Casablanca",
      value: "(GMT+00:00) Casablanca, Monrovia, Reykjavik",
    },
    {
      label: "Etc/Greenwich",
      value:
        "(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London",
    },
    {
      label: "Europe/Amsterdam",
      value: "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
    },
    {
      label: "Europe/Belgrade",
      value: "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
    },
    {
      label: "Europe/Brussels",
      value: "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris",
    },
    {
      label: "Europe/Sarajevo",
      value: "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
    },
    { label: "Africa/Lagos", value: "(GMT+01:00) West Central Africa" },
    { label: "Asia/Amman", value: "(GMT+02:00) Amman" },
    {
      label: "Europe/Athens",
      value: "(GMT+02:00) Athens, Bucharest, Istanbul",
    },
    { label: "Asia/Beirut", value: "(GMT+02:00) Beirut" },
    { label: "Africa/Cairo", value: "(GMT+02:00) Cairo" },
    { label: "Africa/Harare", value: "(GMT+02:00) Harare, Pretoria" },
    {
      label: "Europe/Helsinki",
      value: "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
    },
    { label: "Asia/Jerusalem", value: "(GMT+02:00) Jerusalem" },
    { label: "Europe/Minsk", value: "(GMT+02:00) Minsk" },
    { label: "Africa/Windhoek", value: "(GMT+02:00) Windhoek" },
    { label: "Asia/Kuwait", value: "(GMT+03:00) Kuwait, Riyadh, Baghdad" },
    {
      label: "Europe/Moscow",
      value: "(GMT+03:00) Moscow, St. Petersburg, Volgograd",
    },
    { label: "Africa/Nairobi", value: "(GMT+03:00) Nairobi" },
    { label: "Asia/Tbilisi", value: "(GMT+03:00) Tbilisi" },
    { label: "Asia/Tehran", value: "(GMT+03:30) Tehran" },
    { label: "Asia/Muscat", value: "(GMT+04:00) Abu Dhabi, Muscat" },
    { label: "Asia/Baku", value: "(GMT+04:00) Baku" },
    { label: "Asia/Yerevan", value: "(GMT+04:00) Yerevan" },
    { label: "Asia/Kabul", value: "(GMT+04:30) Kabul" },
    { label: "Asia/Yekaterinburg", value: "(GMT+05:00) Yekaterinburg" },
    {
      label: "Asia/Karachi",
      value: "(GMT+05:00) Islamabad, Karachi, Tashkent",
    },
    {
      label: "Asia/Calcutta",
      value: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi",
    },
    { label: "Asia/Calcutta", value: "(GMT+05:30) Sri Jayawardenapura" },
    { label: "Asia/Katmandu", value: "(GMT+05:45) Kathmandu" },
    { label: "Asia/Almaty", value: "(GMT+06:00) Almaty, Novosibirsk" },
    { label: "Asia/Dhaka", value: "(GMT+06:00) Astana, Dhaka" },
    { label: "Asia/Rangoon", value: "(GMT+06:30) Yangon (Rangoon)" },
    { label: "Asia/Bangkok", value: "(GMT+07:00) Bangkok, Hanoi, Jakarta" },
    { label: "Asia/Krasnoyarsk", value: "(GMT+07:00) Krasnoyarsk" },
    {
      label: "Asia/Hong_Kong",
      value: "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
    },
    {
      label: "Asia/Kuala_Lumpur",
      value: "(GMT+08:00) Kuala Lumpur, Singapore",
    },
    { label: "Asia/Irkutsk", value: "(GMT+08:00) Irkutsk, Ulaan Bataar" },
    { label: "Australia/Perth", value: "(GMT+08:00) Perth" },
    { label: "Asia/Taipei", value: "(GMT+08:00) Taipei" },
    { label: "Asia/Tokyo", value: "(GMT+09:00) Osaka, Sapporo, Tokyo" },
    { label: "Asia/Seoul", value: "(GMT+09:00) Seoul" },
    { label: "Asia/Yakutsk", value: "(GMT+09:00) Yakutsk" },
    { label: "Australia/Adelaide", value: "(GMT+09:30) Adelaide" },
    { label: "Australia/Darwin", value: "(GMT+09:30) Darwin" },
    { label: "Australia/Brisbane", value: "(GMT+10:00) Brisbane" },
    {
      label: "Australia/Canberra",
      value: "(GMT+10:00) Canberra, Melbourne, Sydney",
    },
    { label: "Australia/Hobart", value: "(GMT+10:00) Hobart" },
    { label: "Pacific/Guam", value: "(GMT+10:00) Guam, Port Moresby" },
    { label: "Asia/Vladivostok", value: "(GMT+10:00) Vladivostok" },
    {
      label: "Asia/Magadan",
      value: "(GMT+11:00) Magadan, Solomon Is., New Caledonia",
    },
    { label: "Pacific/Auckland", value: "(GMT+12:00) Auckland, Wellington" },
    {
      label: "Pacific/Fiji",
      value: "(GMT+12:00) Fiji, Kamchatka, Marshall Is.",
    },
    { label: "Pacific/Tongatapu", value: "(GMT+13:00) Nuku alofa" },
  ];

  const { state } = useLocation();

  const [user, setUser] = useState("");
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
  const [timezone, setTimeZone] = useState([]);
  const [language, setLanguage] = useState("");
  const [phone, setPhone] = useState("");
  const [work_phone, setWork_Phone] = useState("");
  const [email, setEmail] = useState("");

  const [successful, setSuccessful] = useState(false);
  const [disable, setDisable] = useState(false);
  const [loading, setLoading] = useState(false);
  const checkBtn = useRef();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const form = useRef();

  useEffect(() => {
    EditUserService.getUser(state).then((response) => {
      setName(response.data.name);
      setTitle(response.data.title);
      setTimeZone(response.data.timezone);
      setLanguage(response.data.language);
      setPhone(response.data.phone);
      setWork_Phone(response.data.work_phone);
      setEmail(response.data.user_email);
      setUser(response.data.user);

      reset({
        name: response.data.name,
        timezone: response.data.timezone,
      });
    })
   
  }, []);

  let navigate = useNavigate();

  const handleRegister = () => {
    setSuccessful(false);
    setLoading(true);
    setDisable(true);
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      EditUserService.editUser(
        state,
        name,
        title,
        language,
        timezone,
        email,
        work_phone,
        phone,
        user
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setLoading(false);
          setTimeout(() => {
            setDisable(false);
            navigate("/user");
          }, 2000);
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSuccessful(false);
          setDisable(false);
          setLoading(false);

        }
      })
     
    }
  };

  const handelClick = () => {
    navigate("/user");
  };
  const [password, setPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [cnfPassword, setCnfPassword] = useState('')
  const handleChangePassword = () => {
    if (cnfPassword === newPassword) {
      AuthUserChangePassword.UserPassword({
        email: (email),
        password: cnfPassword,
        currentpassword: password
      }).then((res) => {
        if (res.data.success === 0) {
          toast.error(res.data.error,
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
        } else {
          toast.success(res.data.response,
            {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
            // localStorage.setItem("last_login",res.data.lastlogin)
          setTimeout(() => {
            // navigate("/profile");
          }, 3000);
        }
      })
     
    } else {
      toast.error('Confirm Password and New Password not same',
        {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        })
    }

  }
  // const handleChangeUserPassword = () => {
  //   confirmAlert({
  //     title: <h3 className="tc">Change Password</h3>,
  //     message: <div className="">
  //       <label>Current Password</label>
  //                   <div className="mb-3">
  //                     <input
  //                       className="form-control  validate black-text"
  //                       name="Password"
  //                       type="Password"
  //                       placeholder='Password'
  //                       onChange={(e) => setPassword(e.target.value)}
  //                     />
  //                   </div>
  //                   <label>New Password</label>
  //                   <div className="mb-3">
  //                     <input
  //                       className="form-control  validate black-text"
  //                       name="Password"
  //                       type="Password"
  //                       placeholder='Password'
  //                       onChange={(e) => setNewPassword(e.target.value)}
  //                     />
  //                   </div>
  //                   <label>Confirm Password</label>
  //                   <div className="mb-3">
  //                     <input
  //                       className="form-control"
  //                       name="password2"
  //                       type="password"
  //                       placeholder='Confirm Password'
  //                       onChange={(e) => setCnfPassword(e.target.value)}
  //                     />
  //                   </div>
    
  //     </div>,
  //     buttons: [
  //       {
  //         label: "Confirm",
  //         onClick: () => {
  //           handleChangePassword()
  //           // handlechangeusersubscription()
  //         },
  //         className:'confirm-button'
  //       },
  //       {
  //         label: "No",
  //         // style:{
  //         //   background:'grey',
  //         //   color:'white'
  //         // },
  //         className:'no-button'
  //       },
  //     ],
  //   });
  // }

  const handleChangeUserPassword = () => {
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      // AuthService.forgotpassword(email).then(
      AuthService.resetpassword(email).then(
        (data) => {
          if (data.data.success === 1) {
            toast.success("Successfully send email",
              {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
          }
          else {
            toast.error(`${data.data.error}`,
              {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
          }
        },
      )
      
    } else {
    }
  };


  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="header pt-3">
            <h5 className="mb-3 tc">{t("Edit User")}</h5>
          </div>
          <ToastContainer />
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <Form
                    role="form text-left"
                    onSubmit={handleSubmit(handleRegister)}
                    ref={form}
                    action="."
                    method="POST"
                    id="addPartyForm"
                  >
                    {
                      <>
                        <div className="form-group row">
                          <div className="col-md-6">
                            <label className="col-form-label">
                              {t("Title")}{" "}
                              <Tooltip content={t("Title_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <select
                              type="text"
                              className="form-control form-select"
                              name="title"
                              placeholder="Title"
                              value={title}
                              onChange={(e) => setTitle(e.target.value)}
                            >
                              <option value="">{t("Select Title")}</option>
                              {option3.map((option) => (
                                <option value={option.label}>
                                  {option.value}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-md-6">
                            <label className="col-form-label required">
                              {t("Name")}{" "}
                              <Tooltip content={t("Name_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="name"
                              placeholder="Name"
                              value={name}
                              {...register("name", {
                                onChange: (e) => {
                                  setName(e.target.value);
                                },
                                required: true,
                              })}
                            />
                            <div className="invalid-feedback">
                              {errors.name?.type === "required" &&
                                "Name  is required"}
                            </div>
                          </div>
                        </div>
                        <div className="form-group row">
                          <div className="col-md-6">
                            <label className="col-form-label">
                              {t("Language")}{" "}
                              <Tooltip content={t("Language_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <select
                              type="text"
                              className="form-control form-select"
                              name="language"
                              value={language}
                              onChange={(e) => setLanguage(e.target.value)}
                            >
                              <option>{t("Select Language")}</option>
                              {option2.map((option) => (
                                <option value={option.label}>
                                  {option.value}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="col-sm-6">
                            <label className="col-form-label required">
                              {t("Timezone")}{" "}
                              <Tooltip content={t("Timezone_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <select
                              type="text"
                              name="timezone"
                              value={timezone}
                              className="form-control form-select"
                              {...register("timezone", {
                                onChange: (e) => {
                                  setTimeZone(e.target.value);
                                },
                                required: true,
                              })}
                            >
                              <option value="">{t("Select Timezone")}</option>
                              {option.map((option) => (
                                <option value={option.label}>
                                  {option.value}
                                </option>
                              ))}
                            </select>
                            <div className="invalid-feedback">
                              {errors.timezone?.type === "required" &&
                                "Timezone  is required"}
                            </div>
                          </div>
                        </div>
                        <div className="form-group row">
                          <div className="col-sm-6">
                            <label className="col-form-label required">
                              {t("Email")}{" "}
                              <Tooltip content={t("Email_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <input
                              type="email"
                              disabled
                              className="form-control"
                              name="email"
                              placeholder="Email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                          </div>
                          <div className="col-sm-6">
                            <label className="col-form-label">
                              {t("Phone")}{" "}
                              <Tooltip content={t("Phone_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="phone"
                              placeholder="Phone"
                              value={phone}
                              onChange={(e) => setPhone(e.target.value)}
                            />
                          </div>
                          <div className="col-sm-6">
                            <label className="col-form-label">
                              {t("Work Phone")}{" "}
                              <Tooltip content={t("WorkPhone_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="workphone"
                              placeholder="Work Phone"
                              value={work_phone}
                              onChange={(e) => setWork_Phone(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="text-left py-3">
                          <button
                            type="button"
                            onClick={handelClick}
                            className="btn btn-secondary btn-md"
                          >
                            {t("Cancel")}
                          </button>
                          &nbsp;
                          <button
                            type="submit"
                            disabled={disable}
                            className="border-0 btn btn-primary btn-gradient-primary btn-md"
                          >
                            {loading === false ? t("Save") : <ButtonLoading />}
                          </button>
                          &nbsp;&nbsp;
                          {/* <button
                            type="button"
                            onClick={() => handleChangeUserPassword()}
                            className="border-0 btn btn-primary btn-gradient-primary btn-md"
                          >
                            { t("Change Password")}
                          </button> */}
                          <button
                            type="button"
                            onClick={() => handleChangeUserPassword()}
                            className="border-0 btn btn-primary btn-gradient-primary btn-md"
                          >
                            { t("Reset Password")}
                          </button>
                          &nbsp;&nbsp;
                        </div>
                      </>
                    }
                    <CheckButton style={{ display: "none" }} ref={checkBtn} />
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditUser;
